import { useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { clarityRoleTag, identifyClarityUser, initClarity } from '../../lib/clarity';

export function ClarityBootstrap() {
  const { authUser, userDoc } = useAuth();

  useEffect(() => {
    initClarity();
  }, []);

  useEffect(() => {
    if (!authUser) return;
    identifyClarityUser(authUser.uid, {
      role: userDoc ? clarityRoleTag(userDoc) : undefined,
      tenant: userDoc?.lastSelectedTenantSlug,
    });
  }, [authUser, userDoc]);

  return null;
}
